import lrRichDg from './_src/lrRichDg.vue'

lrRichDg.install = function(Vue) {
  Vue.component(lrRichDg.name, lrRichDg)
}

export default lrRichDg